import { render, staticRenderFns } from "./UserWidget.vue?vue&type=template&id=562c516b&scoped=true"
import script from "./UserWidget.vue?vue&type=script&lang=js"
export * from "./UserWidget.vue?vue&type=script&lang=js"
import style0 from "./UserWidget.vue?vue&type=style&index=0&id=562c516b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c516b",
  null
  
)

export default component.exports